import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=7cfb03f5"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"
import style0 from "./couponList.vue?vue&type=style&index=0&id=7cfb03f5&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cfb03f5')) {
      api.createRecord('7cfb03f5', component.options)
    } else {
      api.reload('7cfb03f5', component.options)
    }
    module.hot.accept("./couponList.vue?vue&type=template&id=7cfb03f5", function () {
      api.rerender('7cfb03f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/thirdSam/couponList.vue"
export default component.exports